import * as types from '../API/ActionTypes';
import InitialState from './initialState';

export function customerListErrorReducer(state = InitialState.customerOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.CUSTOMER_LIST_ERROR:
			return action.customerOutputErrorFlag;
		default:
			return state;
	}
}

export function customerListLoadingReducer(state = InitialState.customerOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.CUSTOMER_LIST_LOADING:
			return action.customerOutputDataLoading;
		default:
			return state;
	}
}

export function customerListReducer(state = InitialState.customerOutputData, action) 
{
	switch (action.type) 
	{
		case types.CUSTOMER_LIST:
			return action.customerOutputData;
		default:
			return state;
	}
}
